export default __webpack_public_path__ + "static/commercial-sales-fc5c4fbca10f4c1ff7442c542b45fc74.png";